/* eslint-disable no-console */
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useErrorMessage from '../../../shared/hooks/useErrorMessage';
import { useTranslation } from 'react-i18next';
import ContainerFloatCenter from '../../../theme/ui/Layout/ContainerFloatCenter';
import { SSOLoginManager } from '../../../redux/auth-manager/action/thunks';
import { useAppDispatch } from '../../../redux/store.model';

export function OIDCCallback() {
  const navigate = useNavigate();
  const errorMessage = useErrorMessage();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(globalThis.location.search);
  //console.log('OIDCCallback: searchParams', searchParams.toString());

  // Protect against React strict mode double-invocation
  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (hasProcessedRef.current) {
      return;
    }
    hasProcessedRef.current = true;

    const processCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          const errorDescription =
            searchParams.get('error_description') || error;
          errorMessage(errorDescription);
          navigate('/login');
          return;
        }

        if (!code) {
          errorMessage(
            t('error.auth_code_missing') || 'Authorization code not found'
          );
          navigate('/login');
          return;
        }

        try {
          const result = await dispatch(SSOLoginManager({ code }));
          console.log('OIDCCallback: SSOLoginManager dispatch result', result);
          navigate('/', { replace: true });
          globalThis.history.replaceState(null, '', '/#/');
        } catch (error) {
          console.error('OIDCCallback: SSOLoginManager dispatch error:', error);
          errorMessage(
            error || t('error.token_exchange_failed') || 'Authentication failed'
          );
          navigate('/login', { replace: true });
          globalThis.history.replaceState(null, '', '/#/login');

          return;
        }
      } catch (error: any) {
        console.error('OIDCCallback: OAuth callback error:', error);
        errorMessage(
          error.message || t('error.auth_failed') || 'Authentication failed'
        );
        navigate('/login', { replace: true });
        globalThis.history.replaceState(null, '', '/#/login');
      }
    };

    processCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContainerFloatCenter>
      <Box textAlign="center">
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {t('login.processing_login') || 'Processing login...'}
        </Typography>
      </Box>
    </ContainerFloatCenter>
  );
}

export default OIDCCallback;
